// extracted by mini-css-extract-plugin
export default {"container":"_60060571","title":"_a6acdff6"};